// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.echart[data-v-853b24b6] {\n  width: 100%;\n  height: 325px; \n  overflow-y: auto;\n  scrollbar-width: thin;\n}\n.bar[data-v-853b24b6] {\n  max-width: 100%;\n  background-color: white; \n  border: 1px solid #E5E5E5; \n  border-radius: 10px; \n  padding: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
